export default __webpack_public_path__ + "static/media/discord.9a8a5bc4.svg";